import React from "react";

const DownloadIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_1625_48" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1625_48)">
        <path
          d="M5.49698 17.0834V15.609L6.23414 14.8719H3.58991C3.16897 14.8719 2.81266 14.726 2.521 14.4344C2.22933 14.1427 2.0835 13.7864 2.0835 13.3655V4.42317C2.0835 4.00222 2.22933 3.64591 2.521 3.35425C2.81266 3.06258 3.16897 2.91675 3.58991 2.91675H10.1845V4.16673H3.58991C3.5258 4.16673 3.46703 4.19344 3.4136 4.24685C3.36018 4.30028 3.33348 4.35905 3.33348 4.42317V13.3655C3.33348 13.4296 3.36018 13.4883 3.4136 13.5417C3.46703 13.5952 3.5258 13.6219 3.58991 13.6219H16.4104C16.4745 13.6219 16.5333 13.5952 16.5867 13.5417C16.6401 13.4883 16.6668 13.4296 16.6668 13.3655V10.8334H17.9168V13.3655C17.9168 13.7864 17.771 14.1427 17.4793 14.4344C17.1876 14.726 16.8313 14.8719 16.4104 14.8719H13.7661L14.5033 15.609V17.0834H5.49698ZM12.7966 12.2036L8.92648 8.33339L9.80464 7.45521L12.1717 9.81742V2.91675H13.4216V9.81742L15.7886 7.45521L16.6668 8.33339L12.7966 12.2036Z"
          fill="#2F80ED"
        />
      </g>
    </svg>
  );
};

export default DownloadIcon;
